import React, { Component } from 'react';

import Utils from '../utils/mci-utils';

export class Input extends Component{

    constructor(props){
        super(props);

        this.state = {
            error: false,
            errorMessage: '',
            showError: false
        };
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            value: nextProps.value,
            showError: nextProps.showError
        });

        //nextProps.showError ? this.validateInput() : '';
        if(nextProps.showError){
            this.validateInput()
        }
    }

    validateInput = (e) =>{
        const {  value, label, validations } = this.props;
        let errorObj = {};

        // Required
        if(validations.indexOf('required') !== -1 && value === ''){
            errorObj = {
                error: true, 
                errorMessage: label + ' is required'
            };
        }

        // Email
        else if(validations.indexOf('email') !== -1 && !Utils.isEmailAddress(value)){

            errorObj = {
                error: true,
                errorMessage: 'Enter a valid email address'
            };
        }
        
        // TIN
        else if(validations.indexOf('tin') !== -1){
            
        }

        else{
            errorObj = {
                error: false,
                errorMessage: ''
            };
        }

        this.setState(errorObj);
    }

    render(){
        // console.log(this.state);

        const { error, errorMessage } = this.state;
        const {
            value, 
            name, 
            
            placeholder,
            type,
            
            autoFocus,
            onChangeFn
        } = this.props;

        let errorClass = error ? ' has-error' : '';

        return(

            <div className={ 'form-group' + errorClass }>
                <input
                    className="form-control" 
                    type={ type }
                    placeholder={ placeholder }
                    name={ name }
                    value={ value }
                    autoFocus={ autoFocus }
                    onChange={ onChangeFn }
                    onBlur={ this.validateInput } />
                
                { 
                    error ?
                        <div className="help-block">{ errorMessage }</div>
                    :
                        null
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Inputs.jsx